import React, { PropTypes } from "react";
import { MultiGrid, AutoSizer, CellMeasurerCache } from "react-virtualized";
import { categoryType } from "custom-prop-types";
import styles from "components/manage-categories/manage-categories.scss";
import { Button } from "components/common/button";
import { AutomateInlineTabs } from "components/common/automate-inline-tabs";
import { AddCategoryModal } from "components/manage-categories/add-category-modal";
import { DeleteCategoriesModal } from "components/manage-categories/delete-categories-modal";
import { CellRenderer, getGridHeight } from "components/grid/grid-components";
import { CategoryDropdown } from "components/manage-categories/category-dropdown";
import { NoItems } from "components/common/no-items";

export const ManageCategories = (props) => (
  <div className={ styles.container }>
    <AutomateInlineTabs currentPage="manage-categories" slug={ props.slug } />
    <h1>Manage Categories</h1>
    <div className={ styles["controls-container"] }>
      <Button
        danger
        disabled={ props.selectedCategoryIds.length === 0 }
        onClick={ props.onShowDeleteCategories }
      >
        Delete Categories
      </Button>
      <Button onClick={ props.onShowAddCategory } primary>Add category</Button>
    </div>
    <div className={ styles["grid-container"] }>
      <AutoSizer disableHeight>
        {({ width }) => (
          <MultiGrid
            { ...props }
            cache={ cache }
            cellRenderer={ ({ ...gridProps }) => <CellRenderer { ...gridProps } newKey={ gridProps.key } /> }
            classNameBottomRightGrid={ styles["bottom-grid"] }
            classNameTopRightGrid={ styles["top-grid"] }
            columnCount={ columns.length }
            columns={ columns }
            columnWidth={ ({ index }) => getColumnWidth(index, width, columns.length) }
            deferredMeasurementCache={ cache }
            documents={ props.categories }
            fixedRowCount={ 1 }
            height={ getGridHeight(-1, props.categories.length, rowHeight) }
            isRowFocusable
            isSelectable
            noContentRenderer={ () => <NoItems name={ "categories" } /> }
            onFocusRow={ props.onFocusCategory }
            rowCount={ props.categories.length + 1 }
            rowHeight={ rowHeight }
            selectedDocumentIds={ props.selectedCategoryIds }
            width={ width }
          />
        )}
      </AutoSizer>
      <CategoryDropdown { ...props } rowHeight={ rowHeight } />
    </div>
    <AddCategoryModal { ...props } />
    <DeleteCategoriesModal { ...props } />
  </div>
);

ManageCategories.defaultProps = {
  focusedCategory: null
};

ManageCategories.propTypes = {
  categories: PropTypes.arrayOf(categoryType).isRequired,
  onFocusCategory: PropTypes.func.isRequired,
  onShowAddCategory: PropTypes.func.isRequired,
  onShowDeleteCategories: PropTypes.func.isRequired,
  selectedCategoryIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  slug: PropTypes.string.isRequired
};

const rowHeight = 45;
const columns = [
  {
    key: "select",
    visible: true
  },
  {
    key: "name",
    name: "Name",
    sortable: true,
    visible: true
  },
  {
    key: "receipts",
    name: "Number of Receipts",
    sortable: true,
    visible: true
  },
  {
    key: "rules",
    name: "Always add to vendor",
    sortable: true,
    visible: true
  }
];

const getColumnWidth = (index, width, columnsLength) => {
  switch (index) {
    case 0:
      return 75;
    default:
      return (width - 75) / (columnsLength - 1);
  }
};

const cache = new CellMeasurerCache({
  defaultWidth: 300,
  minWidth: 250
});



// WEBPACK FOOTER //
// ./src/js/components/manage-categories/manage-categories.jsx